import { render, staticRenderFns } from "./customizedDetail.vue?vue&type=template&id=ea37f242&scoped=true&"
import script from "./customizedDetail.vue?vue&type=script&lang=js&"
export * from "./customizedDetail.vue?vue&type=script&lang=js&"
import style0 from "./customizedDetail.vue?vue&type=style&index=0&id=ea37f242&lang=less&scoped=true&"
import style1 from "./customizedDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea37f242",
  null
  
)

export default component.exports